export type UpDownColorOption = '- Auto -' | 'Blue' | 'Cyan' | 'Purple' | 'Pink' | 'Red' | 'Orange' | 'Brown' | 'Gold' | 'Green' | 'Lime' | 'Black' | 'Gray' | 'Light Gray' | 'Dark Gray' | 'White' | 'Yellow' | 'Magenta';

export const UP_DOWN_COLOR_OPTION_AUTO: UpDownColorOption = '- Auto -';
export const UP_DOWN_COLOR_OPTION_BLUE: UpDownColorOption = 'Blue';
export const UP_DOWN_COLOR_OPTION_CYAN: UpDownColorOption = 'Cyan';
export const UP_DOWN_COLOR_OPTION_PURPLE: UpDownColorOption = 'Purple';
export const UP_DOWN_COLOR_OPTION_PINK: UpDownColorOption = 'Pink';
export const UP_DOWN_COLOR_OPTION_RED: UpDownColorOption = 'Red';
export const UP_DOWN_COLOR_OPTION_ORANGE: UpDownColorOption = 'Orange';
export const UP_DOWN_COLOR_OPTION_BROWN: UpDownColorOption = 'Brown';
export const UP_DOWN_COLOR_OPTION_GOLD: UpDownColorOption = 'Gold';
export const UP_DOWN_COLOR_OPTION_GREEN: UpDownColorOption = 'Green';
export const UP_DOWN_COLOR_OPTION_LIME: UpDownColorOption = 'Lime';
export const UP_DOWN_COLOR_OPTION_BLACK: UpDownColorOption = 'Black';
export const UP_DOWN_COLOR_OPTION_GRAY: UpDownColorOption = 'Gray';
export const UP_DOWN_COLOR_OPTION_LIGHT_GRAY: UpDownColorOption = 'Light Gray';
export const UP_DOWN_COLOR_OPTION_DARK_GRAY: UpDownColorOption = 'Dark Gray';
export const UP_DOWN_COLOR_OPTION_WHITE: UpDownColorOption = 'White';
export const UP_DOWN_COLOR_OPTION_YELLOW: UpDownColorOption = 'Yellow';
export const UP_DOWN_COLOR_OPTION_MAGENTA: UpDownColorOption = 'Magenta';
